import { render, staticRenderFns } from "./AccountantViewBB.vue?vue&type=template&id=7959f814&"
import script from "./AccountantViewBB.vue?vue&type=script&lang=js&"
export * from "./AccountantViewBB.vue?vue&type=script&lang=js&"
import style0 from "./AccountantViewBB.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports